"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAYMENT_METHOD_IMAGE_URL = exports.DEFAULT_AVATAR_IMAGE_URL = void 0;
exports.DEFAULT_AVATAR_IMAGE_URL = 'https://d3sdeiz39xdvhy.cloudfront.net/assets/default-avatar.png';
exports.DEFAULT_PAYMENT_METHOD_IMAGE_URL = 'https://d3sdeiz39xdvhy.cloudfront.net/assets/default-payment-method-image.png';
